import type Shape from '../objects/Shape';
import type Wireframe from '../objects/Wireframe';
import { AhaEditorUtils } from '@aha-app/aha-editor-v2';

type ColorableObject = Shape | Wireframe;

export function getTextColorFromSelection(selection: fabric.Object): string {
  return getTextColorFromObject(selection.firstObject());
}

export function getTextColorFromObject(object: ColorableObject): string {
  return (
    ('readTextProperty' in object &&
      object.readTextProperty(editor => {
        let color: string = '#000000';
        const textColorMark = AhaEditorUtils.Marks.getMarkAtSelection(
          editor,
          'textColor'
        );
        if (typeof textColorMark === 'string') {
          color = textColorMark;
        }

        return color;
      })) ||
    object.textColor
  );
}
